String.prototype.interpolate = function (params: object) {
    const names = Object.keys(params);
    const values = Object.values(params);
    let stringWithReplace = this.toString();

    if (names.length === values.length) {
        for (let i = 0; i < names.length; i++) {
            stringWithReplace = stringWithReplace.replace('{' + names[i] + '}', values[i]);
        }
    }

    return stringWithReplace;
};

String.prototype.transformUrl = function (values: object) {
    return this.interpolate(values);
};
